const config = {
  //Production // Real
  // API_URL: 'http://147.139.133.49:8080',
  //development //coba-coba
  // API_URL: "http://Novitra.top:1010",
  //   API_URL: "https://znzc9zzrhx.ap.loclx.io/",
  //local bang epit
  // API_URL: 'http://192.168.18.4:8080',
  API_URL: "https://api-payment.novitra.id",
};

export default config;
